export const tariffCodes = [
  { code: 'İŞY', name: 'İŞYERİ YANGIN' },
  { code: 'KNT', name: 'KONUT YANGIN' },
];

export const parameters = [
  {
    tariffCode: ['KNT', 'MKP', 'SKL'],
    parameters: [
      { name: '001', value: '0', type: 'TEMINAT', description: 'Bina Bedeli Teminatı' },
      { name: '003', value: '0', type: 'TEMINAT', description: 'Eşya Bedeli Teminatı' },
      { name: '008', value: '0', type: 'TEMINAT', description: 'Yangın Mali Sorumluluk Teminatı' },
      { name: '016', value: '0', type: 'TEMINAT', description: 'Cam Kırılması Teminatı' },
      { name: 'X70', value: '0', type: 'TEMINAT', description: 'Makine Tesisat Teminatı' },
      {
        name: '59',
        value: '0',
        type: 'TEMINAT',
        description: 'Enflasyon Oranı',
        valueList: ['50', '60', '65', '70', '75', '80', '90'],
      },
    ],
  },
  {
    tariffCode: ['İŞY', 'İŞK'],
    parameters: [
      { name: 'Z33', value: '0', type: 'TEMINAT', description: 'Bina Yangın Teminatı' },
      { name: 'H04', value: '0', type: 'TEMINAT', description: 'Dekorasyon Yangın Teminatı' },
      { name: 'X49', value: '0', type: 'TEMINAT', description: 'Demirbaş EC Yangın Teminatı' },
      { name: 'Z29', value: '0', type: 'TEMINAT', description: 'Emtea Yangın Teminatı' },
      { name: 'H03', value: '0', type: 'TEMINAT', description: '3.Şahıs Malları Yangın Teminatı' },
      { name: 'Z31', value: '0', type: 'TEMINAT', description: 'Makine Tesisat Yangın Teminatı' },
      { name: 'H35', value: '0', type: 'TEMINAT', description: 'Kasa Yangın Teminatı' },
      { name: 'Z37', value: '0', type: 'TEMINAT', description: 'Cam Kırılması Teminatı' },
      { name: 'Z39', value: '0', type: 'TEMINAT', description: 'Yangın Mali Sorumluluk Teminatı' },
      { name: 'Z36', value: '0', type: 'TEMINAT', description: 'Kazı Sonucu Yer Kayması Teminatı' },
      {
        name: 'S41',
        value: '0',
        type: 'TEMINAT',
        description: 'Enflasyon Oranı',
        valueList: ['50', '60', '65', '70', '75', '80', '90'],
      },
    ],
  },
];
